import { Steps } from "antd"
import DashboardWrapper from "components/new-stuff/ui/DashboardWrapper"
import React, { useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import StatsPage from "./component/StatsPage"
import { Button } from "components"
import { isKenyaCurrency } from "utils/currency"

const StatustoryPayment = () => {
  const [current, setCurrent] = useState(0)
  const location = useLocation()
  const navigate = useNavigate()
  const [{ title, currency_code: stateCurrencyCode }] = useState(
    () => location.state || {}
  )
  // Prefer the URL so the selected currency survives a refresh, a fresh tab or
  // a shared link; history state is only a fallback for older entry points.
  const currency_code =
    new URLSearchParams(location.search).get("s") || stateCurrencyCode
  const onChange = (value: number) => {
    setCurrent(value)
  }
  const next = () => {
    setCurrent(current + 1)
  }

  const prev = () => {
    setCurrent(current - 1)
  }
  const payments = [
    {
      id: "regular-payment-tax",
      title: "Tax Summary",
      content: (
        <StatsPage
          currency_code={currency_code}
          StatName="Tax"
          StatNameSmall="tax"
          ItemId="2"
          StatustoryId={2}
        />
      ),
    },

    {
      id: "regular-payment-pension",
      title: "Pension Summary",
      content: (
        <StatsPage
          currency_code={currency_code}
          StatName="Pension"
          StatNameSmall="pension"
          ItemId="3"
          StatustoryId={1}
        />
      ),
    },
    {
      id: "regular-payment-nhf",
      title: "NHF Summary",
      content: (
        <StatsPage
          currency_code={currency_code}
          StatName="NHF"
          StatNameSmall="nhf"
          ItemId="4"
          StatustoryId={3}
        />
      ),
    },

    {
      id: "regular-payment-nsitf",
      title: "NSITF Summary",
      content: (
        <StatsPage
          currency_code={currency_code}
          StatName="NSITF"
          StatNameSmall="nsitf"
          ItemId="9"
          StatustoryId={4}
        />
      ),
    },
    {
      id: "regular-payment-itf",
      title: "ITF Summary",
      content: (
        <StatsPage
          currency_code={currency_code}
          StatName="ITF"
          StatNameSmall="itf"
          ItemId="10"
          StatustoryId={5}
        />
      ),
    },
    {
      id: "regular-payment-ewa",
      title: "EWA Summary",
      content: (
        <StatsPage
          currency_code={currency_code}
          StatName="EWA"
          StatNameSmall="ewa"
          ItemId="8"
          showReportBtn={false}
          showPrepareBtn={false}
        />
      ),
    },
    // {
    //   id: "regular-payment-nhis",
    //   title: "NHIS summary",
    //   content: (
    //     <StatsPage
    //       currency_code={currency_code}
    //       StatName="EWA"
    //       StatNameSmall="ewa"
    //       ItemId="8"
    //     />
    //   ),
    // },
  ]

  const isGhana = currency_code === "GHS"

  const ghanaPayments = [
    {
      id: "ssnit",
      title: "SSNIT",
      content: (
        <StatsPage
          currency_code={currency_code}
          StatName="SSNIT"
          StatNameSmall="ssnit"
          ItemId="14"
          StatustoryId={14}
        />
      ),
    },
    {
      id: "regular-payment-tax",
      title: "Tax Summary",
      content: (
        <StatsPage
          currency_code={currency_code}
          StatName="Tax"
          StatNameSmall="tax"
          ItemId="2"
          StatustoryId={2}
        />
      ),
    },
  ]

  // Kenya is PAYE-only with no pension/NHF/NSITF/ITF/WHT. NSSF, SHIF and the
  // Housing Levy are remitted instead. They have no report page yet.
  const kenyaPayments = [
    ghanaPayments[1],
    {
      id: "nssf",
      title: "NSSF",
      content: (
        <StatsPage
          currency_code={currency_code}
          StatName="NSSF"
          StatNameSmall="nssf"
          ItemId="15"
          StatustoryId={7}
          showReportBtn={false}
        />
      ),
    },
    {
      id: "shif",
      title: "SHIF",
      content: (
        <StatsPage
          currency_code={currency_code}
          StatName="SHIF"
          StatNameSmall="shif"
          ItemId="16"
          StatustoryId={8}
          showReportBtn={false}
        />
      ),
    },
    {
      id: "housing-levy",
      title: "Housing Levy",
      content: (
        <StatsPage
          currency_code={currency_code}
          StatName="Housing Levy"
          StatNameSmall="housing-levy"
          ItemId="17"
          StatustoryId={9}
          showReportBtn={false}
        />
      ),
    },
  ]

  const activePayments = isGhana
    ? ghanaPayments
    : isKenyaCurrency(currency_code)
    ? kenyaPayments
    : payments

  return (
    <DashboardWrapper>
      <div className="relative">
        <h6 className="text-sm text-padeBlack font-circular mb-3">
          Payment for {title}
        </h6>
        <Steps
          current={current}
          onChange={onChange}
          labelPlacement="vertical"
          className="font-avenir !text-neutral300"
          progressDot={false}
          // size="small"
          // type="navigation"
          items={activePayments.map((item) => ({
            title: item.title,
            key: item?.title,
          }))}
        />
        <div>{activePayments[current].content}</div>

        <div className="fixed bottom-0 flex justify-end left-0 right-0 h-[64px] gap-4  py-3 px-16 bg-white ">
          <Button
            color="secondary"
            onClick={() => navigate(-1)}
          >
            Skip to Payouts
          </Button>
          {current < activePayments.length - 1 && (
            <Button
              color="primary"
              onClick={() => next()}
            >
              Next
            </Button>
          )}
        </div>
      </div>
    </DashboardWrapper>
  )
}

export default StatustoryPayment
